export const Modals = (function () {
	'use strict';

	function init() {

		// $('iframe').addClass('lazyload lazy');

		if ('loading' in HTMLIFrameElement.prototype) {
			const iframes = document.querySelectorAll('iframe[loading="lazy"]');
			iframes.forEach(iframe => {
				let iframeSrc = iframe.src;
			});
		} else {
			const script = document.createElement('script');
			script.src =
				'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.2.2/lazysizes.min.js';
			document.body.appendChild(script);
		}

		MicroModal.init({
			onShow: (modal) => {
				const lazyIframe = modal.querySelector('[lazy-iframe]')
				lazyIframe && (lazyIframe.innerHTML = lazyIframe.getAttribute('lazy-iframe'))

				history.replaceState(null, null, `#${modal.id}`);
				document.body.classList.add('modal--is-open');
			},
			onClose: (modal) => {
				const lazyIframe = modal.querySelector('[lazy-iframe]')
				lazyIframe && (lazyIframe.innerHTML = '')

				let loopVideos = document.querySelectorAll('.media-bg--loop > video');
				loopVideos.forEach((loopVideo) => loopVideo.play());

				history.replaceState(null, null, ' ');
				document.body.classList.remove('modal--is-open');

			},
		});

		document.querySelectorAll('[data-micromodal-trigger]').forEach((item) => {
			const id = item.getAttribute('data-micromodal-trigger')
			const iframe = document.querySelector(`#${id} .iframe`)
			if (iframe) {
				iframe.setAttribute('lazy-iframe', iframe.innerHTML.trim())
				iframe.innerHTML = ''
			}
			item.addEventListener('click', (e) => {
				e.preventDefault();
			});
		});

		const hash = window.location.hash;
		if (hash) {
			const $el = document.querySelector(`[data-micromodal-trigger=${hash.replace('#', '')}]`)
			$el && $el.click()
		}
	}

	return {
		init: init,
	};
})();
